export default [
  {
    title: 'Women',
    links: [
      {
        href: '/indianwear/c/4',
        text: 'Indianwear',
      },
      {
        href: '/westernwear/c/3',
        text: 'Westernwear',
      },
      {
        href: '/bags/c/89',
        text: 'Bags',
      },
      {
        href: '/accessories/footwear/c/3528',
        text: 'Footwear',
      },
      {
        href: '/lingerie/c/3946?',
        text: 'Lingerie',
      },
      {
        href: '/jewellery/c/77',
        text: 'Jewellery',
      },
      {
        href: '/accessories/c/104',
        text: 'Accessories',
      },
      {
        href: '/accessories/watches/c/4641',
        text: 'Watches',
      },
      {
        href: '/women/sportswear/c/4015',
        text: 'Sportswear',
      },
    ],
  },
  {
    title: 'Men',
    links: [
      {
        href: '/men/topwear/c/6824',
        text: 'Topwear',
      },
      {
        href: '/men/bottoms/c/6834?',
        text: 'Bottomwear',
      },
      {
        href: '/men/footwear/c/6857',
        text: 'Footwear',
      },
      {
        href: '/mens/personal-accessories/c/6879',
        text: 'Personal Accessories',
      },
      {
        href: '/men/ethnicwear/c/6841',
        text: 'Ethnic Wear',
      },
      {
        href: '/mens/innerwear-sleepwear/c/6850',
        text: 'Innerwear',
      },
      {
        href: '/mens/watches/c/6875',
        text: 'Watches',
      },
      {
        href: '/mens/sports-and-athleisure/c/6888',
        text: 'Sportswear',
      },
      {
        href: '/mens/bags-and-backpacks/c/6867',
        text: 'Bags and Backpacks',
      },
    ],
  },
  {
    title: 'Kids',
    links: [
      {
        href: '/kids/westernwear/c/6282',
        text: 'Westernwear',
      },
      {
        href: '/kids/indianwear/c/6267',
        text: 'Indianwear',
      },
      {
        href: '/kids/footwear/c/6333',
        text: 'Footwear',
      },
      {
        href: '/kids/accessories/c/6343',
        text: 'Accessories',
      },
      {
        href: '/kids/toys-and-games/c/6382',
        text: 'Toys and Games',
      },
      {
        href: '/kids/sportswear/c/6298',
        text: 'Sportswear',
      },
      {
        href: '/kids/feeding/c/6351',
        text: 'Feeding',
      },
      {
        href: '/kids/home/c/6376',
        text: 'Home',
      },
      {
        href: '/kids/innerwear/c/6329',
        text: 'Innerwear',
      },
    ],
  },
  {
    title: 'Luxe',
    links: [
      {
        href: '/luxe/c/6800?f=category_filter%3D4497_7_',
        text: 'Separates',
      },
      {
        href: '/luxe/c/6800?f=category_filter%3D10_',
        text: 'Sarees',
      },
      {
        href: '/luxe/c/6800?f=category_filter%3D4543_5_',
        text: 'Dresses',
      },
      {
        href: '/luxe/c/6800?f=category_filter%3D69_',
        text: 'Kurta Sets',
      },
      {
        href: '/luxe/c/6800?f=category_filter%3D652_',
        text: 'Lehengas',
      },
      {
        href: '/luxe/c/6800?f=category_filter%3D78_88_79_394_724_3972_3969_3971_4540__',
        text: 'Jewellery',
      },
      {
        href: '/luxe/c/6800?f=category_filter%3D90_92_3686_91_3944_669__',
        text: 'Bags',
      },
      {
        href: '/luxe/c/6800?f=category_filter%3D6028__',
        text: 'Masks',
      },
    ],
  },
  {
    title: 'Top Brands',
    links: [
      {
        href: '/designers/aachho/c/5625',
        text: 'Aachho',
      },
      {
        href: '/designers/forever-new/c/4495',
        text: 'Forever New',
      },
      {
        href: '/designers/biba/c/5274',
        text: 'Biba',
      },
      {
        href: '/designers/reebok/c/7199',
        text: 'Reebok',
      },
      {
        href: '/designers/adidas/c/7200',
        text: 'Adidas',
      },
      {
        href: '/designers/lavanya-the-label/c/5141',
        text: 'Lavanya the Label',
      },
      {
        href: '/designers/forever-21/c/7105',
        text: 'Forever 21',
      },
      {
        href: '/designers/gap/c/6269',
        text: 'Gap',
      },
      {
        href: '/designers/w/c/4038',
        text: 'W',
      },
      {
        href: '/designers/puma/c/4886',
        text: 'Puma',
      },
    ],
  },
  {
    title: 'House of Nykaa',
    links: [
      {
        href: '/designers/twenty-dresses/c/4240',
        text: '20 Dresses by Nykaa Fashion',
      },
      {
        href: '/designers/mondano/c/4942',
        text: 'Mondano by Nykaa Fashion',
      },
      {
        href: '/designers/rsvp/c/4706',
        text: 'RSVP by Nykaa Fashion',
      },
      {
        href: '/designers/likhha-silver/c/5058',
        text: 'Likha by Nykaa Fashion',
      },
      {
        href: '/designers/nykd-by-nykaa/c/7059',
        text: 'Nykd by Nykaa',
      },
      {
        href: '/designers/pipa-bella/c/3771',
        text: 'Pipa Bella',
      },
    ],
  },
];
